<div class="selectDebitContainer" id="selectDebitContainer">
  <h1 class="selectDebitTitle" id="selectDebitTitle">
    Automatiza tus pagos vinculando una de tus cuentas de ahorros
  </h1>
  <button
    class="selectDebitAddBtn"
    id="selectDebitAddBtn"
    (click)="handleAddCredit(2)"
    [disabled]="!entitys"
  >
    Agregar cuenta +
  </button>
  <span class="selectDebitLine" id="selectDebitLine"></span>
  <div
    *ngIf="debits"
    class="selectDebitAccountsContainer"
    id="selectDebitAccountsContainer"
  >
    <label
      *ngFor="let debit of debits"
      class="selectDebitAccountCard"
      id="selectDebitAccountCard"
    >
      <div
        class="selectDebitAccountCardContent"
        id="selectDebitAccountCardContent"
      >
        <div
          class="selectDebitAccountCardContentTitle"
          id="selectDebitAccountCardContentTitle"
        >
          <img [src]="debit.url" alt="" />
          <h1>{{ debit.Nombre }}</h1>
        </div>
        <h2>Número de Cuenta: {{ maskText(debit.numeroCuenta) }}</h2>
      </div>
      <input
        type="radio"
        name="debitRadio"
        [value]="debit"
        [(ngModel)]="selectedDebit"
      />
    </label>
  </div>
  <div
    *ngIf="!debits && message"
    class="selectDebitAccountsContainerNot"
    id="selectDebitAccountsContainerNot"
  >
    <h1>{{ message }}</h1>
  </div>
  <div class="selectDebitButtonsGroup" id="selectDebitButtonsGroup">
    <button
      [disabled]="!selectedDebit"
      class="selectDebitSelectedButton"
      id="selectDebitSelectedButton"
      (click)="handleSelectedDebit()"
    >
      Elegir
    </button>
    <button
      class="selectDebitCancelButton"
      id="selectDebitCancelButton"
      (click)="handleCancelBtn()"
      *ngIf="visbleCancel"
    >
      Cancelar
    </button>
  </div>
</div>
